import { render } from "./tablePageBtn.vue?vue&type=template&id=7df74ea8"
import script from "./tablePageBtn.vue?vue&type=script&lang=js"
export * from "./tablePageBtn.vue?vue&type=script&lang=js"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__